<template>
  <div class="flex items-start profile-role-hld">
    <div
      class="profile-image-circle"
      style="height: 50px; width: 50px; margin-right: 10px; margin-top: 5px"
    >
      <img
        v-if="
          params.CheckinRoles &&
          params.checkinRoleList &&
          getImage(params.CheckinRoles[0], params.checkinRoleList)
        "
        height="36px"
        width="36px"
        :src="getImage(params.CheckinRoles[0], params.checkinRoleList)"
      />
      <img
        v-else-if="params.CheckinRoles && params.CheckinRoles.length > 0"
        height="36px"
        width="36px"
        src="../../../../assets/images/checkin-images/role-default.svg"
      />
      <!-- <div
        v-else
        style="height:36px;width:36px;"
      ></div> -->
      <!-- <span v-else>{{ getInitials(getName(params.CheckinRoles[0], params.checkinRoleList)) }}</span> -->
    </div>
    <div class="role-hld">
      <div
        v-if="
          params.CheckinRoles &&
          params.checkinRoleList &&
          getName(params.CheckinRoles[0], params.checkinRoleList)
        "
        class="role-name-hld"
        style="line-height: 48px"
      >
        {{ getName(params.CheckinRoles[0], params.checkinRoleList) }}
        <!-- <span v-if="params.CheckinRoles.length > 1">
          {{ " +" + (params.CheckinRoles.length - 1) }}
        </span> -->
        <vx-tooltip
          v-if="getNames(params.CheckinRoles, params.checkinRoleList)"
          :text="getNames(params.CheckinRoles, params.checkinRoleList)"
          position="top"
        >
          <span v-if="params.CheckinRoles.length > 1">
            {{ " +" + (params.CheckinRoles.length - 1) }}
          </span>
        </vx-tooltip>
        <!-- <div class="info-option-wrapper">
          <span v-if="params.CheckinRoles.length > 1">
            {{ " +" + (params.CheckinRoles.length - 1) }}
          </span>
          <div class="popup-info-tooltips">
            <img
              src="../../../assets/images/Live-stage-logo.jpg"
              alt="Display"
            />
          </div>
        </div> -->
        <!-- <vx-tooltip :text="getNames(params.checkinRoleList)" position="top">
          <span v-if="params.CheckinRoles.length > 1">
            {{ " +" + (params.CheckinRoles.length - 1) }}
          </span>
        </vx-tooltip> -->
        <!-- <VTooltip :model-value="isTooltipVisible" location="top">
          <template #activator="{ props }">
            <VIcon v-bind="props" icon="tabler-brand-instagram" />
          </template>
          <span>Programmatic tooltip</span>
        </VTooltip> -->
        <!-- <vx-tooltip
          location="top"
          transition="scale-transition"
          activator="parent"
        >
          <span>Scale Transition</span>
        </vx-tooltip> -->
        <!-- <vx-tooltip
          text="Announcement mail is used to inform attendees of an important info related to the event. eg Event starts in 15 mins"
          position="top"
        >
          <feather-icon class="ml-2" icon="InfoIcon" title="Info" />
        </vx-tooltip> -->
        <!-- <vx-tooltip text="Add New Attendee" position="bottom">
          <span v-if="params.CheckinRoles.length > 1">
            {{ " +" + (params.CheckinRoles.length - 1) }}
          </span>
          <template #tooltip> This is a beautiful button </template>
        </vx-tooltip> -->
      </div>
      <div v-else class="role-name-hld" style="line-height: 48px">
        Not Mapped
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CellRendererRole",
  methods: {
    getInitials: function (str) {
      var result = "";
      if (str) {
        str = str.trim();
        if (str) {
          var matches = str.match(/\b(\w)/g);
          if (matches) {
            result = matches.join("");
            if (result.length > 2) {
              result = result.substring(0, 2);
            }
          } else {
            result = str.substring(0, 2);
          }
        }
      }
      return result.toUpperCase();
    },
    getName(id, checkinRoleList) {
      var result = "Not Mapped";
      for (let i = 0; i < checkinRoleList.length; i++) {
        if (checkinRoleList[i].RoleId == id) {
          result = checkinRoleList[i].Name;
          break;
        }
      }
      return result;
    },
    getNames(checkinRoles, checkinRoleList) {
      var result = "";
      for (let i = 0; i < checkinRoleList.length; i++) {
        if (checkinRoles.includes(checkinRoleList[i].RoleId)) {
          result += checkinRoleList[i].Name + ", ";
        }
      }
      if (result.length > 0) {
        result = result.substring(0, result.length - 2);
      }
      //alert(result)
      return result;
    },
    getImage(id, checkinRoleList) {
      var result = "";
      for (let i = 0; i < checkinRoleList.length; i++) {
        if (checkinRoleList[i].RoleId == id) {
          result = checkinRoleList[i].ImageUrl;
          break;
        }
      }
      return result;
    },
  },
  computed: {},
};
</script>
<style scoped>
.profile-image-circle img,
.profile-image-circle span {
  line-height: 36px;
  text-align: center;
  font-size: 1.4em;
  font-weight: bold;
  display: inline-block;
  height: 36px;
  width: 36px;
  /* border: 1px solid #000; */
  border-radius: 50%;
  background: #dbdbdb;
}
.role-name-hld .con-vs-tooltip {
  display: inline-block !important;
}
.role-name-hld .info-option-wrapper {
  display: inline-block !important;
}
</style>